import React from 'react';

const KeyOfferings: React.FC = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="mb-5">Key Offerings</h1>
          <p className="lead mb-4">
            Comprehensive solutions for every water treatment need
          </p>
        </div>
        <div className="row g-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-drafting-compass fa-2x text-primary mb-3"></i>
                <h5 className="fw-bold">Design & Engineering</h5>
                <p>Bespoke treatment solutions with engineering excellence.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-tint fa-2x text-info mb-3"></i>
                <h5 className="fw-bold">Water Treatment Plants</h5>
                <p>Complete WTP solutions for all industrial applications.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-recycle fa-2x text-success mb-3"></i>
                <h5 className="fw-bold">Effluent & Sewage Treatment</h5>
                <p>ETP/STP systems for environmental compliance.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-microscope fa-2x text-secondary mb-3"></i>
                <h5 className="fw-bold">Lab Testing & Quality</h5>
                <p>Advanced water quality analysis & monitoring.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-flask fa-2x text-warning mb-3"></i>
                <h5 className="fw-bold">Water Treatment Chemicals</h5>
                <p>Specialty & commodity chemicals including RO antiscalants.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-tools fa-2x text-dark mb-3"></i>
                <h5 className="fw-bold">O&M Services – Industrial Plants</h5>
                <p>Operation & maintenance of industrial WTP/STP/ETP units.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-users-cog fa-2x text-primary mb-3"></i>
                <h5 className="fw-bold">Municipal O&M & Manpower</h5>
                <p>Manpower & services for municipal water systems.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-search fa-2x text-info mb-3"></i>
                <h5 className="fw-bold">Consultancy & Water Audits</h5>
                <p>WTP/STP consultancy, audits & performance reviews.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-project-diagram fa-2x text-success mb-3"></i>
                <h5 className="fw-bold">EPC Project Execution</h5>
                <p>Turnkey project execution from design to commissioning.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-industry fa-2x text-secondary mb-3"></i>
                <h5 className="fw-bold">Fabrication & Related Work</h5>
                <p>Custom fabrication for water treatment infrastructure.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-wrench fa-2x text-warning mb-3"></i>
                <h5 className="fw-bold">AMC & Monitoring Services</h5>
                <p>Maintenance contracts with continuous system monitoring.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-cogs fa-2x text-danger mb-3"></i>
                <h5 className="fw-bold">Utilities & Engineering Services</h5>
                <p>Engineering utilities for plant performance enhancement.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-user-friends fa-2x text-dark mb-3"></i>
                <h5 className="fw-bold">Manpower Supply</h5>
                <p>Technical staffing for industrial & municipal projects.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-city fa-2x text-primary mb-3"></i>
                <h5 className="fw-bold">Municipal & Industrial Treatment</h5>
                <p>End-to-end water treatment solutions</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-sync-alt fa-2x text-info mb-3"></i>
                <h5 className="fw-bold">Revamping & Upgrades</h5>
                <p>Capacity expansion & efficiency improvements.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-tint-slash fa-2x text-success mb-3"></i>
                <h5 className="fw-bold">Wastewater Recycling</h5>
                <p>Solutions for sustainable wastewater reuse.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-filter fa-2x text-secondary mb-3"></i>
                <h5 className="fw-bold">RO Membranes & Spares</h5>
                <p>Reverse osmosis components & systems.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-vial fa-2x text-warning mb-3"></i>
                <h5 className="fw-bold">De-Mineralized Water Systems</h5>
                <p>High-purity water solutions for industrial needs.</p>
              </div>
            </div>
          </div>

          <div className="col wow fadeInUp">
            <div className="card h-100 shadow-sm text-center">
              <div className="card-body">
                <i className="fas fa-flask fa-2x text-danger mb-3"></i>
                <h5 className="fw-bold">ETP/STP Chemicals</h5>
                <p>Specialized chemicals for effluent/sewage treatment.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyOfferings;
